// 轮播图
const state = {
  currentId: '' // 当前选中幻灯片
}
const mutations = {
  UPDATECURRENTID(state, currentId) {
    state.currentId = currentId
  }
}
const actions = {
  updateCurrentId({ commit }, currentId) {
    commit('UPDATECURRENTID', currentId)
  }
}
export default {
  namespaced: true,
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/swiper.js